<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'view',
    subject: 'Role',
  },
})

const page = {
  groupTitle: 'Administrasi',
  icon: 'ri-shield-keyhole-line',
  color: 'error',
  title: 'Kelola Role & Permission',
  description: 'Mengatur hak akses tiap role terhadap fitur QUALIVA.',
  purpose: 'Panduan mengubah permission (izin akses) yang dimiliki sebuah role.',
  concept: [
    {
      icon: 'ri-team-line',
      title: 'Role = Kumpulan Izin',
      text: 'QUALIVA sudah dilengkapi 10 role standar rumah sakit/klinik (Direktur, Ketua Tim Mutu, Kepala Unit, dst.) yang izinnya sudah diatur mengikuti tanggung jawab masing-masing jabatan.',
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Perubahan Berlaku Segera',
      text: 'Setelah Anda simpan perubahan permission sebuah role, seluruh user dengan role itu langsung mendapat/kehilangan akses begitu mereka refresh halaman — tidak perlu logout/login ulang.',
    },
  ],
  steps: [
    { title: 'Buka menu Administrasi → Roles', detail: 'Lihat daftar seluruh role dalam bentuk kartu.' },
    { title: 'Klik "Kelola Permission" pada role yang ingin diubah', detail: 'Muncul daftar seluruh permission yang ada, dikelompokkan per modul.' },
    { title: 'Centang/hapus centang permission yang diinginkan', detail: 'Klik nama kelompok untuk centang/hapus sekaligus semua permission dalam kelompok itu.' },
    { title: 'Klik "Simpan Permission"', detail: 'Perubahan langsung berlaku untuk seluruh user dengan role tersebut.' },
  ],
  warning: 'Hati-hati memberi permission role.update/role.create ke role selain administrasi — role yang bisa mengubah role bisa memberi dirinya sendiri akses ke seluruh fitur.',
  tips: [
    'Role super-admin tidak bisa diubah/dihapus — ini dilindungi sistem supaya instalasi tidak pernah kehilangan admin dengan akses penuh.',
    'Review permission setiap role secara berkala, terutama setelah ada perubahan struktur organisasi.',
  ],
  faq: [
    { q: 'Bisakah saya membuat role baru selain 10 role standar?', a: 'Bisa — klik "+ Tambah Role" di halaman daftar role, lalu atur permission-nya seperti biasa.' },
  ],
  related: [
    { title: 'Kelola User', sub: 'Assign role ke akun pegawai', icon: 'ri-user-settings-line', color: 'error', to: { name: 'help-administrasi-kelola-user' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
